import React from 'react'
import { useReactiveVar } from '@apollo/client'
import { Box, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { useTranslation } from 'react-i18next'
import { activeVersionVar } from '../../../apollo/reactive-vars'
import { SingleSettingSection } from '../../common/SingleSettingSection'
import { isConnectedToEnergyBus } from '../../../building/building-util'

export function EnergyBusBasicInfoTab(): React.ReactElement {
  const activeVersion = useReactiveVar(activeVersionVar)
  const { t } = useTranslation()

  const buildings = activeVersion?.buildings ?? []

  const buildingsConnectedToEnergyBus = buildings.filter(isConnectedToEnergyBus)

  return (
    <Box>
      <SingleSettingSection
        title={t('energyBus.tabs.basicInfo.pumpConnections')}
      >
        <Autocomplete
          id="energy-bus-pumps"
          options={buildingsConnectedToEnergyBus}
          getOptionLabel={(building) =>
            t('energyBus.tabs.basicInfo.pumpConnectionOptions', {
              buildingName: building.name,
            })
          }
          getOptionSelected={(option, value) => option.id === value.id}
          value={buildingsConnectedToEnergyBus}
          renderInput={(params) => <TextField {...params} />}
          multiple
          disabled
        />
      </SingleSettingSection>
    </Box>
  )
}
